<template>
  <div class="avatar">
    <router-link :to="viewProfile(user)">
      <img :src="user.picture">
    </router-link>
  </div>
</template>

<script>
import { viewProfile } from '../utils/routing'
export default {
  props: ['user'],
  methods: {
    viewProfile,
  },
}
</script>

<style lang="stylus" scoped>
.avatar
  img
    max-width 50px
    border-radius 10%
</style>
